/**
 * faqData.js - Mock FAQ data
 * 
 * Used for: FAQ page, FAQ sections in other pages
 * 
 * Categories:
 * - Genel
 * - Fiyatlandırma
 * - Teknik
 * - Güvenlik
 * - Hukuki
 */

export const faqData = [
  // Genel
  {
    id: 1,
    question: 'ContractCode nedir?',
    answer: 'ContractCode, profesyonel hukuki belgelerinizi hızlı ve kolay bir şekilde oluşturmanızı sağlayan bir platformdur. Akıllı form sistemiyle sorulara cevap vererek dakikalar içinde hukuki belgelerinizi hazırlayabilirsiniz.',
    category: 'Genel',
  },
  {
    id: 2,
    question: 'Nasıl çalışır?',
    answer: 'Sadece 3 adımda belgelerinizi hazırlayabilirsiniz: 1) İhtiyacınız olan belge şablonunu seçin, 2) Akıllı form üzerinden soruları cevaplayın, 3) Belgenizi PDF veya Word formatında indirin.',
    category: 'Genel',
  },
  {
    id: 3,
    question: 'Hangi belgeler mevcut?',
    answer: 'İş sözleşmeleri, kira sözleşmeleri, gizlilik anlaşmaları, ihtar mektupları, vekaletnameler ve daha birçok hukuki belge şablonu platformumuzda mevcuttur. Toplamda 100+ şablon bulunmaktadır.',
    category: 'Genel',
  },
  {
    id: 4,
    question: 'Oluşturduğum belgeler geçerli mi?',
    answer: 'Evet, tüm şablonlarımız deneyimli hukukçular tarafından hazırlanmıştır ve mevzuata uygundur. Ancak özel durumlar için bir avukata danışmanızı öneririz.',
    category: 'Genel',
  },
  
  // Fiyatlandırma
  {
    id: 5,
    question: 'Ücretsiz deneme süresi ne kadar?',
    answer: '14 gün boyunca ücretsiz deneyebilirsiniz. Kredi kartı bilgisi gerektirmez. Deneme süresince tüm özelliklere tam erişim sağlarsınız.',
    category: 'Fiyatlandırma',
  },
  {
    id: 6,
    question: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
    answer: 'Kredi kartı, banka kartı ve havale ile ödeme yapabilirsiniz. Kurumsal müşterilerimiz için fatura ile ödeme seçeneği de mevcuttur.',
    category: 'Fiyatlandırma',
  },
  {
    id: 7,
    question: 'Aboneliğimi iptal edebilir miyim?',
    answer: 'Evet, istediğiniz zaman aboneliğinizi iptal edebilirsiniz. İptal sonrası mevcut dönem sonuna kadar hizmetlerimizden faydalanmaya devam edebilirsiniz.',
    category: 'Fiyatlandırma',
  },
  {
    id: 8,
    question: 'Fatura alabilir miyim?',
    answer: 'Evet, her ödeme sonrası otomatik olarak e-fatura gönderilir. Kurumsal fatura talep ediyorsanız, hesap ayarlarınızdan şirket bilgilerinizi girebilirsiniz.',
    category: 'Fiyatlandırma',
  },
  
  // Teknik
  {
    id: 9,
    question: 'Hangi dosya formatlarında indirebilirim?',
    answer: 'Belgelerinizi PDF, Word (DOCX) ve düz metin (TXT) formatlarında indirebilirsiniz. Pro ve Kurumsal planlarda tüm formatlar mevcuttur.',
    category: 'Teknik',
  },
  {
    id: 10,
    question: 'Mobil cihazlardan kullanabilir miyim?',
    answer: 'Evet, platformumuz responsive tasarıma sahiptir. Telefon, tablet ve bilgisayarınızdan rahatça kullanabilirsiniz.',
    category: 'Teknik',
  },
  {
    id: 11,
    question: 'İnternet bağlantısı olmadan kullanabilir miyim?',
    answer: 'Hayır, ContractCode web tabanlı bir platformdur ve internet bağlantısı gerektirir. Ancak indirdiğiniz belgeleri çevrimdışı kullanabilirsiniz.',
    category: 'Teknik',
  },
  {
    id: 12,
    question: 'Oluşturduğum belgeleri düzenleyebilir miyim?',
    answer: 'Evet, oluşturduğunuz belgeleri istediğiniz zaman tekrar düzenleyebilirsiniz. Belgeleriniz hesabınızda saklanır ve dilediğiniz zaman erişebilirsiniz.',
    category: 'Teknik',
  },
  
  // Güvenlik
  {
    id: 13,
    question: 'Verilerim güvende mi?',
    answer: 'Evet, tüm verileriniz 256-bit SSL şifrelemesi ile korunmaktadır. Sunucularımız ISO 27001 sertifikalıdır ve düzenli güvenlik denetimlerinden geçer.',
    category: 'Güvenlik',
  },
  {
    id: 14,
    question: 'Kişisel verilerim paylaşılıyor mu?',
    answer: 'Hayır, kişisel verileriniz kesinlikle üçüncü taraflarla paylaşılmaz. KVKK ve GDPR uyumlu çalışıyoruz. Gizlilik politikamızdan detaylı bilgi alabilirsiniz.',
    category: 'Güvenlik',
  },
  {
    id: 15,
    question: 'Belgelerim ne kadar süre saklanır?',
    answer: 'Belgeleriniz hesabınız aktif olduğu sürece süresiz olarak saklanır. Hesabınızı kapattıktan 30 gün sonra tüm verileriniz kalıcı olarak silinir.',
    category: 'Güvenlik',
  },
  
  // Hukuki
  {
    id: 16,
    question: 'Avukat onayı gerekli mi?',
    answer: 'Genel durumlar için şablonlarımız yeterlidir. Ancak karmaşık veya özel durumlar için bir avukata danışmanızı öneririz.',
    category: 'Hukuki',
  },
  {
    id: 17,
    question: 'Belgeleriniz noter onaylı mı?',
    answer: 'Belgelerimiz noter onayı gerektirmeyen standart sözleşmelerdir. Noter onayı gereken durumlarda, oluşturduğunuz belgeyi notere götürerek onaylatabilirsiniz.',
    category: 'Hukuki',
  },
  {
    id: 18,
    question: 'Özel şablon oluşturabilir miyim?',
    answer: 'Kurumsal planımızda özel şablon oluşturma hizmeti sunuyoruz. Hukuk ekibimiz sizin için özel şablonlar hazırlayabilir.',
    category: 'Hukuki',
  },
  {
    id: 19,
    question: 'Destek hizmeti var mı?',
    answer: 'Evet, tüm kullanıcılarımıza e-posta desteği sunuyoruz. Pro ve Kurumsal plan kullanıcılarımız öncelikli destek ve canlı destek hizmetinden faydalanabilir.',
    category: 'Genel',
  },
  {
    id: 20,
    question: 'Takım çalışması yapabilir miyim?',
    answer: 'Evet, Pro ve Kurumsal planlarda takım yönetimi özellikleri mevcuttur. Ekip üyelerinizi ekleyebilir, yetki yönetimi yapabilir ve ortak belgeler oluşturabilirsiniz.',
    category: 'Teknik',
  },
];

// Helper function to get FAQs by category
export const getFAQsByCategory = (category) => {
  return faqData.filter(faq => faq.category === category);
};

// Helper function to get all FAQ categories
export const getAllFAQCategories = () => {
  return [...new Set(faqData.map(faq => faq.category))];
};

// Helper function to search FAQs
export const searchFAQs = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return faqData.filter(
    faq =>
      faq.question.toLowerCase().includes(term) ||
      faq.answer.toLowerCase().includes(term)
  );
};

